import NavPages from 'NavPages';
import { HORIZONTAL } from 'constants';

// Language reducer
export const languageReducer = (state = 'fr', action) => {
  switch (action.type) {
    case 'SET_LANGUAGE': {
      return action.language;
    }
    default:
      return state;
  }
};

// SubMenuDirection reducer
export const subMenuDirectionReducer = (state = HORIZONTAL, action) => {
  switch (action.type) {
    case 'SET_SUB_MENU_DIRECTION': {
      return action.subMenuDirection;
    }
    default:
      return state;
  }
};

// Current Navigation Page Reducer
export const currentNavPageReducer = (state = NavPages.HOME_PAGE, action) => {
  switch (action.type) {
    case 'SET_CURRENT_NAV_PAGE': {
      return action.currentNavPage;
    }
    default:
      return state;
  }
};

//SourceToken Reducers
export const sourcesTokensReducer = (state = [], action) => {
  switch (action.type) {
    case 'PUSH_SOURCE_TOKEN': {
      let newItem = {sourceName: action.sourceName, sourceToken: action.sourceToken};
      let filteredItem = state.filter(
        item => item.sourceName === action.sourceName,
      );
      let mappedItems = state.map(
        item => item.sourceName === action.sourceName ? newItem : item,
      );
      let tab = [...state, newItem];
      return filteredItem.length > 0 ? mappedItems : tab;
    }
    case 'CLEAR_SOURCES_TOKENS': {
      return [];
    }
    default:
      return state;
  }
};

const initialStateForTTPDialogReducer = {
  showDialog: false,
  customData: [],
}
export const dialogReducer = (state = initialStateForTTPDialogReducer, action) => {
  switch (action.type) {
    case 'SET_TTP_Dialog_SHOW': {
      return {...state, showDialog: action.showDialog};
    }
    case 'SET_TTP_Dialog_CUSTOM_DATA': {
      return {...state, customData: action.customData};
    }
    default:
      return state;
  }
};

export const setApplication = (state = null, action) => {
  switch (action.type) {
    case "SET_APPLICATION": {
      return action.application || "PAYMENT";
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/params.js